import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import MarketingCard from 'shared/app/components/marketing-card';
import StarbucksRewardsTrademark from 'shared/app/components/starbucks-rewards-trademark';
import { sharedCallsToAction } from 'shared/app/messages/ctas';
import messages from './messages';

const content = {
  title: (
    <FormattedMessage
      {...messages.ctaJoinHeading}
      values={{
        starbucksRewardsTrademark: <StarbucksRewardsTrademark />,
      }}
    />
  ),
  bodyMessage: <FormattedMessage {...messages.ctaJoinFullMessage} />,
  buttonMessage: <FormattedMessage {...sharedCallsToAction.joinNow} />,
};

const StarbucksRewardsMoment = ({ onJoinClick }) => (
  <MarketingCard
    bodyMessage={content.bodyMessage}
    buttonProps={{
      children: content.buttonMessage,
      'data-e2e': 'joinNowButton',
      onClick: onJoinClick,
    }}
    title={content.title}
    titleHeadingLevel="h2"
  />
);

StarbucksRewardsMoment.propTypes = {
  onJoinClick: PropTypes.func,
  className: PropTypes.string,
};

export default StarbucksRewardsMoment;
